import { render, staticRenderFns } from "./specialDetail.vue?vue&type=template&id=9e5c4fbc"
import script from "./specialDetail.vue?vue&type=script&lang=js"
export * from "./specialDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports